import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuthStore, isMockMode } from '../store/authStore'
import Spinner from '../components/common/Spinner'

export default function LoginPage() {
  const { t } = useTranslation('worker')
  const { isAuthenticated, isLoading, error, initAuth } = useAuthStore()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isAuthenticated) {
      initAuth()
    }
  }, [initAuth, isAuthenticated])

  useEffect(() => {
    if (isAuthenticated) navigate('/', { replace: true })
  }, [isAuthenticated, navigate])

  if (isLoading) return <Spinner />

  return (
    <div className="min-h-screen flex items-center justify-center p-6 safe-area-bottom" style={{ background: 'var(--app-page-bg)' }}>
      <div className="text-center space-y-4">
        <div className="text-6xl">🏪</div>
        <h1 className="text-2xl font-bold" style={{ color: 'var(--tg-theme-text-color)' }}>
          {t('login.title')}
        </h1>
        <p className="text-sm opacity-60" style={{ color: 'var(--tg-theme-text-color)' }}>
          {t('login.subtitle')}
        </p>
        {error && (
          <div className="rounded-xl p-3 text-sm" style={{ background: '#ef444420', color: '#ef4444' }}>
            {error}
          </div>
        )}
        {!isLoading && !error && !isMockMode() && (
          <p className="text-sm opacity-40" style={{ color: 'var(--tg-theme-text-color)' }}>
            {t('login.openViaTelegram')}
          </p>
        )}
        {!isLoading && !error && !isMockMode() && (
          <p className="text-xs opacity-30" style={{ color: 'var(--tg-theme-text-color)' }}>
            Dev: add <code>?mock=true</code> to URL
          </p>
        )}
      </div>
    </div>
  )
}
